import { Result, validatedApiCall } from '../api';
import { APIValidationError } from '../../types/api/api.d';
import {
  DNI,
  Phone,
  UUID,
  Address,
  AddressNumber,
  AddressFloor,
  ISO8601DateString,
} from '../../types/standard.d';
import { User } from '../../types/users/users.d';
import { Gender } from '../../types/users/gender.d';
import { Role } from '../../types/auth/roles.d';

export interface UpdateMiembroDTO {
  id: UUID;
  nombre: string;
  apellido1: string;
  apellido2: string;
  dni: DNI;
  telefono: Phone;
  calle: Address;
  numero: AddressNumber;
  piso: AddressFloor;
  genero: Gender;
  fecha_nacimiento: ISO8601DateString;
  role: Role | '';
  entidad_id: UUID | '';
}

export const updateMiembro = async (
  data: UpdateMiembroDTO,
): Promise<Result<User, APIValidationError>> => {
  return validatedApiCall<User>(`/api/miembros/${data.id}`, {
    method: 'PATCH',
    auth: true,
    body: JSON.stringify(data),
  });
};
